import React from "react";

import DataTableColumnHeader from "../../dataTable/DataTableColumnHeader";
import { statusColumn } from "../../dataTable/dataTableColumns";
import DataTableLinkCell from "../../dataTable/DataTableLinkCell";
import StatusTag from "../../encoding/StatusTag";
import { encodingStatusOptions } from "../../encoding/tableParams/encodingColumns";
import { contentPath } from "../../routes/routes";

import type { TFunction } from "i18next";

import type { EncodingJobTableItem } from "../../../hooks/useInProgressEncodingList";
import type { DataTableColumnDef } from "../../dataTable/dataTable.types";

export const ENCODING_PROGRESS_MAX_TABLE_WIDTH = 573;

interface EncodingProgressColumnsOptions {
  t: TFunction;
}

export function getEncodingProgressHref(mediaUuid: string): string | undefined {
  return contentPath("hosted", mediaUuid);
}

// Ni tri ni filtre : les lignes ne bougent pas pendant les mises à jour en direct.
export function encodingProgressColumns({
  t,
}: EncodingProgressColumnsOptions): DataTableColumnDef<EncodingJobTableItem>[] {
  const status = statusColumn<EncodingJobTableItem>(
    "status",
    t("status"),
    encodingStatusOptions(t),
  );

  return [
    { ...status, meta: { ...status.meta, filterOptions: undefined } },
    {
      accessorKey: "type",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("type")} />
      ),
      enableSorting: false,
      meta: { label: t("type"), width: "25%", minWidth: 140, align: "center" },
      cell: ({ row }) => (
        <span className="inline-flex align-middle">
          <StatusTag>{t(`editor-encoding:${row.original.type}`)}</StatusTag>
        </span>
      ),
    },
    {
      accessorKey: "mediaTitle",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      enableSorting: false,
      meta: { label: t("name"), minWidth: 150 },
      cell: ({ row }) => (
        <DataTableLinkCell
          href={getEncodingProgressHref(row.original.mediaUuid)}
        >
          {row.original.mediaTitle}
        </DataTableLinkCell>
      ),
    },
    {
      accessorKey: "progression",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("progress")} />
      ),
      enableSorting: false,
      meta: {
        label: t("progress"),
        width: "20%",
        minWidth: 110,
        align: "center",
      },
      cell: ({ row }) => `${row.original.progression ?? 0}%`,
    },
  ];
}
